<form *ngIf="formGroupForm" [formGroup]="formGroupForm">
  <ng-container *ngIf="availableHardware$ | async as availableHardware">

    <ng-container >
      <mat-form-field appearance="fill">
        <mat-label>Choix du matériel</mat-label>
        <mat-select formControlName="availableHardware">
          <mat-option [value]="NONE_VALUE">Aucun</mat-option>
          <mat-option *ngFor="let hardware of availableHardware" [value]="hardware.id">
            RPI n°{{ hardware.rpi }}<ng-container *ngIf="hardware.internalTag"> / Étiquetage interne n°{{ hardware.internalTag }}</ng-container>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <ng-template #noHardware>
      <div class="empty-hardware-available">
        Aucun matériel n’est actuellement disponible pour être assigné à la communauté.
        Vous pouvez en ajouter un depuis la section Matériels.
      </div>
    </ng-template>

  </ng-container>
</form>
